module.exports = __webpack_public_path__ + "static/img/236434.2a984bf9.png";